import { Emergency } from "@mui/icons-material";
import { SxProps, Theme } from '@mui/material';

export const Links = {
  root: "/",
  dashboard: "/dashboard",
  appointmentHome: "/appointmenthome",
  allAppointments: "/allappointments",
  rescheduleAppointment: "/rescheduleappointment",
  patientDetails: "/patientdetails",
  updatePatient: "/updatepatient",
  newPatient: "/newpatient",
  basicInformation: "/patient/basicinformation",
  prescriptions: "/patient/prescriptions",
  medicalRecords: "/patient/medicalrecords",
  newPrescription: "/newprescription",
  facilityBasicDetails: "/facilitybasicdetails",
  facilityService: "/facilityservices",
  facilityStaff: "/facilitystaff",
  patientAnalytics: "/patientanalytics",
  schedulingAnalytics: "/schedulinganalytics",
  profileSettings: "/profilesettings",
  availabilitySettings: "/availabilitysettings",
  prescriptionSettings: "/prescriptionsettings",
  billing: "/billing",
  billingHome: "/billing/home",  // New Route
  billingList: "/billing/list",  // New Route
  patient: "/patient",
  myWorklist:"/myworklist",
  mySettings: "/mysettings",
  others: "/*",
};

export const MainMenu = {
  dashboard:'Dashboard',
  myWorklist:'MyWorklist',
  appointments: 'Appointments',
  patients: 'Patients',
  billing: 'Billing',
  mySettings: 'MySettings',
  facilitySettings: 'FacilitySettings',
  visits: 'Visits',
}

export const ChartColors = {
  color1: "#38a2ebbf",
  color2: "#f66384bf",
  color3: "#4bc0c0bf",
  color4: "#f89f40bf",
  color5: "#9966ffbf",
  color6: "#c9cbcfbf",
};

export const URLs = {
  AppointmentAPI: "/api/appointment",
  UserAccountAPI: "/api/account",
  FacilityAPI: "/api/facility",
  FacilitySettingsAPI: "/api/facilitysettings",
  ClinicalServiceAPI: "/api/facilitysettings/clinicalservice",
  PatientAPI: "/api/patient",
  PrescriptionAPI: "/api/prescription",
  BillingAPI:"/api/billing",

};

export const PrescriptionTypes = {
  GeneralPrescription: "GeneralPrescription",
  PhysiotherapyPrescription: "PhysiotherapyPrescription",
  DentalPrescription: "DentalPrescription",
};

export const ServiceLocations = {
  Clinic: "Clinic",
  Online: "Online",
  Home: "Home",
};

export const Prefixes = ["Mr.", "Mrs.", "Ms.", "Dr.", "Baby", "Others"];

export const Genders = ["Male", "Female", "Others", "Unknown"];

export const BloodGroupOptions = [
  {value:"APositive", displayValue:"A+"}, 
  {value:"ANegative", displayValue:"A-"}, 
  {value:"BPositive", displayValue:"B+"}, 
  {value:"BNegative", displayValue:"B-"}, 
  {value:"OPositive", displayValue:"O+"}, 
  {value:"ONegative", displayValue:"O-"}, 
  {value:"ABPositive", displayValue:"AB+"}, 
  {value:"ABNegative", displayValue:"AB-"}, 
  {value:"Unknown", displayValue:"Unknown"}, 
];

export const SelectableMedicalHistoryConditions = [
  {value:"Diabetes", selected:false, displayValue:"Diabetes"}, 
  {value:"Hypertension", selected:false, displayValue:"Hypertension"}, 
  {value:"Asthma", selected:false, displayValue:"Asthma"}, 
  {value:"HeartDisease", selected:false, displayValue:"Heart Disease"}, 
  {value:"Thyroid", selected:false, displayValue:"Thyroid"}, 
  {value:"Epilepsy", selected:false, displayValue:"Epilepsy"}, 
];
export const SelectableComorbidities = [
  {value:"Anemia", selected:false, displayValue:"Anemia"},
  {value:"Obesity", selected:false, displayValue:"Obesity"},
  {value:"Cancer", selected:false, displayValue:"Cancer"},
  {value:"COPD", selected:false, displayValue:"COPD"},
  {value:"ChronicKidneyDisease", selected:false, displayValue:"Chronic Kidney Disease"},
  {value:"LiverDisease", selected:false, displayValue:"Liver Disease"},
  {value:"Stroke", selected:false, displayValue:"Stroke"},
  {value:"AutoimmuneDisorder", selected:false, displayValue:"Autoimmune Disorder"},
  {value:"Diabetes", selected:false, displayValue:"Diabetes"}, 
  {value:"Hypertension", selected:false, displayValue:"Hypertension"}, 
  {value:"Asthma", selected:false, displayValue:"Asthma"}, 
  {value:"HeartDisease", selected:false, displayValue:"Heart Disease"}, 
  {value:"Thyroid", selected:false, displayValue:"Thyroid"}, 
  {value:"Epilepsy", selected:false, displayValue:"Epilepsy"}, 
  {value:"Other", selected:false, displayValue:"Other", additionalText:""},
];
export const SelectablePainType = [
  {value:"Constant", selected:false, displayValue:"Constant"}, 
  {value:"Intermittent", selected:false, displayValue:"Intermittent"}, 
  {value:"Radiating", selected:false, displayValue:"Radiating"}, 
  {value:"Throbbing", selected:false, displayValue:"Throbbing"}, 
  {value:"PinsNeedles", selected:false, displayValue:"Pins and Needles"}, 
  {value:"Burning", selected:false, displayValue:"Burning"}, 
];
export const PhysioTreatmentMethods = [
  {value:"IFT", selected:false, displayValue:"IFT"}, 
  {value:"MFR", selected:false, displayValue:"MFR"}, 
  {value:"UltraSound", selected:false, displayValue:"UltraSound"}, 
  {value:"Tens", selected:false, displayValue:"TENS"}, 
  {value:"StrengtheningExercise", selected:false, displayValue:"Strengthening Exercise"}, 
  {value:"FlexibilityExercise", selected:false, displayValue:"Flexibility Exercise"}, 
  {value:"CoreStability", selected:false, displayValue:"Core Stability"},
  {value:"Others", selected:false, displayValue:"Others", additionalText:""}, 
];

export const NationalIdTypes = [
  "Aadhaar",
  "Passport",
  "PAN Card",
  "Driving License",
  "Govt. Employee Id",
];

export const AppointmentStatus = {
  Scheduled: "Scheduled",
  CheckedIn: "CheckedIn",
  NoShow: "NoShow",
  Cancelled: "Cancelled",
  InProgress: "InProgress",
  Completed: "Completed",
};

export const ServiceStatus = {
  NotStarted: "NotStarted",
  InProgress: "InProgress",
  Completed: "Completed", 
};

export const BillingStatus = {
  NotStarted: "NotBilled",
  InProgress: "AddedToBill",
  Completed: "BillFinalized", 
};

export const VisitTypes = {
  OPD: "OPD",
  Home: "Home",
  Online: "Online", 
  IPD: "IPD", 
  Emergency: "Emergency", 
};
  

export const DateRangeOptions = {
  Today: "Today",
  Yesterday: "Yesterday",
  Next7Days: "Next7Days",
  Last7Days: "Last7Days",
  Last30Days: "Last30Days",
  Next30Days: "Next30Days",
  Custom: "Custom",
};



export const PaymentModes = [
  {value: "Cash", displayValue:"Cash"},
  {value: "CreditCard", displayValue:"Credit Card"},
  {value: "DebitCard", displayValue:"Debit Card"},
  {value: "NetBanking", displayValue:"Net Banking"},
  {value: "UPI", displayValue:"UPI"},
  {value: "AccountTransfer", displayValue:"Account Transfer"},
  {value: "CreditNote", displayValue: "Credit Note"},  
]

export const RefundPaymentModes = [
  {value: "Cash", displayValue:"Cash"},
  {value: "UPI", displayValue:"UPI"},
  {value: "CreditNote", displayValue:"Credit Note"},
  {value: "AccountTransfer", displayValue:"Account Transfer"},
  {value: "Cheque", displayValue:"Cheque"},
];

export const TestNames = [
  "ANA",
  "Blood Culture",
  "Blood Grouping & Rh Typing",
  "Blood Sugar (Fasting)",
  "Blood Sugar (PP)",
  "Bone Density (DEXA)",
  "Chest X-Ray",
  "Complete Blood Count (CBC)",
  "COVID-19 RT-PCR",
  "CRP",
  "CT Scan",
  "D-Dimer",
  "ECG",
  "Electrolytes",
  "ESR",
  "Hepatitis B Surface Antigen (HBsAg)",
  "HIV Test",
  "Lipid Profile",
  "Liver Function Test (LFT)",
  "Mammography",
  "MRI",
  "Pap Smear",
  "Procalcitonin",
  "PT/INR",
  "RA Factor",
  "Renal Function Test (RFT)",
  "Serum Albumin",
  "Serum Bilirubin",
  "Serum Calcium",
  "Serum Creatinine",
  "Serum Potassium",
  "Serum Sodium",
  "Stool Culture",
  "Stool Routine",
  "Thyroid Profile (T3, T4, TSH)",
  "Ultrasound Abdomen",
  "Urine Culture",
  "Urine Pregnancy Test",
  "Urine Routine",
  "Vitamin B12",
  "Vitamin D"
];

export const MedicineDurationOptions = [
  "1 day",
  "2 days",
  "3 days",
  "5 days",
  "7 days",
  "10 days",
  "14 days",
  "21 days",
  "1 month",
  "2 months",
  "3 months",
  "Until finished",
  "As directed",
  "Single dose"
];

export const iconButtonStyles = {
  circularSecondary: {
    borderRadius: '50%',
    width: '28px',
    height: '28px',
    padding: '4px',
    border: '1px solid',
    borderColor: 'secondary.main',
    '&:hover': {
      backgroundColor: 'rgba(0, 0, 0, 0.04)',
    }
  },
  // Add other common button styles here as needed
  circularPrimary: {
    borderRadius: '50%',
    width: '28px',
    height: '28px',
    padding: '4px',
    border: '1px solid',
    borderColor: 'primary.main',
    '&:hover': {
      backgroundColor: 'rgba(25, 118, 210, 0.04)',
    }
  }
};
 export const paymentModes = [
    "Cash",
    "CreditCard",
    "DebitCard",
    "NetBanking",
    "UPI",
    "AccountTransfer",
    "CreditNote",
    "Cheque"
  ];
   export const refundPaymentModes = [ 
    "Cash",
    "UPI",
    "CreditNote",
    "AccountTransfer",
    "Cheque",
   ];

export  const recordTypeOptions = [
  "Laboratory Result",
  "Discharge Summary",
  "Consent Form",
  "Prescription",
  "Radiology Reports",
  "Administrative Data",
  "Medical History",
  "Operative Report",
  "Pathology Report",
  "Others",
];

export  const roleOptions = [
  "FacilityAdmin",
  "Physician",
  "FrontDesk",
  "Nurse",
  "Accountant",
  "LabTechnician",
  "Pharmacist",
  "InventoryManager"
];

